var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './video-hero.styles';
import { classMap } from 'lit/directives/class-map.js';
import { dictionaryPreload } from '@mf-cms/helpers';
let PVideoHero = class PVideoHero extends LitElement {
    constructor() {
        super(...arguments);
        this.videoBaseUrl = '';
        this.headingTag = 'h2';
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
     * First updated lifecycle
     * @returns {void}
     */
    async firstUpdated() {
        this.accessToken = window.getAccessToken();
        if (this.featuredVideoId) {
            this.featuredVideo = await this.getVideo(parseInt(this.featuredVideoId));
            // Override video values if specified in the component
            if ((!this.image || this.image == 'placeholder') && this.featuredVideo?.poster) {
                this.image = this.featuredVideo.poster;
            }
            if (!this.heading && this.featuredVideo?.name) {
                this.heading = this.featuredVideo.name;
            }
            if (!this.description && this.featuredVideo?.description) {
                this.description = this.featuredVideo.description;
            }
            if (!this.link && this.featuredVideo) {
                this.link = `${this.videoBaseUrl}/${this.featuredVideo.id}`;
                this.isVideo = true;
            }
        }
    }
    async updated() {
        if (this.featuredVideoId != this.featuredVideo?.id) {
            this.featuredVideo = await this.getVideo(parseInt(this.featuredVideoId));
        }
        if (this.featuredVideo) {
            // Override video values if specified in the component
            if ((!this.image || this.image == 'placeholder') && this.featuredVideo?.poster) {
                this.image = this.featuredVideo.poster;
            }
            if (!this.heading && this.featuredVideo?.name) {
                this.heading = this.featuredVideo.name;
            }
            if (!this.description && this.featuredVideo?.description) {
                this.description = this.featuredVideo.description;
            }
            if (!this.link && this.featuredVideo) {
                this.link = `${this.videoBaseUrl}/${this.featuredVideo.id}`;
                this.isVideo = true;
            }
        }
    }
    /**
     * Get video
     *
     * @param {number} id - Video id
     * @returns {Promise<any>} Video
     */
    async getVideo(id) {
        try {
            const response = await fetch(`${process.env.API_URL}/file/${id}?fields=any&access_token=${this.accessToken}`);
            const json = await response.json();
            return json[0];
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const classes = {
            'hide-text': this.hideText,
            preview: this.preview
        };
        return html ` <section class="video-hero${classMap(classes)}"> <div class="featured-poster"> <figure> ${this.image ? html `<img draggable="false" src=${this.image} alt=${this.alt} />` : ''}
          </figure>
        </div>
        <div class="container">
          <div class="featured-content">
            <div class=${this.hideText ? 'sr-only' : ''}>
              ${this.headingTag == 'h1'
            ? html `<h1>${this.heading}</h1>`
            : html `<h2>${this.heading}</h2>`}
              ${this.description ? html `<p>${this.description}</p>` : ''}
            </div>

            ${this.link
            ? html ` ${this.isVideo ? html `
                        <p-button color="primary" href=${this.link}>
                          <svg
                            aria-hidden="true"
                            slot="prefix"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-play-fill"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"
                            />
                          </svg>
                          ${dictionaryPreload(this.culture, 'videoHero', 'playVideo')}
                        </p-button>
                      `
                : html ` <p-button color="primary" href=${this.link}> ${dictionaryPreload(this.culture, 'videoHero', 'readMore')} </p-button> `}
                `
            : ''}
          </div>
          <div class="grid">
            <slot name="card"></slot>
          </div>
        </div>
      </section>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true, attribute: 'featured-video-id' })
], PVideoHero.prototype, "featuredVideoId", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoHero.prototype, "image", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoHero.prototype, "heading", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoHero.prototype, "description", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoHero.prototype, "alt", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoHero.prototype, "link", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-video' })
], PVideoHero.prototype, "isVideo", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PVideoHero.prototype, "preview", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'video-base-url' })
], PVideoHero.prototype, "videoBaseUrl", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'heading-tag' })
], PVideoHero.prototype, "headingTag", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'hide-text' })
], PVideoHero.prototype, "hideText", void 0);
__decorate([
    property({ type: String })
], PVideoHero.prototype, "culture", void 0);
PVideoHero = __decorate([
    customElement('p-video-hero')
    /**
     * PVideoHero component
     *
     * @class PVideoHero
     * @typedef {PVideoHero}
     * @extends {LitElement}
     */
], PVideoHero);
export { PVideoHero };
